import { PropsWithChildren } from "react";

import { Box } from "emoreg/layouts";

export const DropdownPopOverContent = ({ children }: PropsWithChildren<{}>) => {
  return <Box padding={4}>{children}</Box>;
};
